import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import Sidebar from './Sidebar';
import { getTeamMembers, createTeamMember, updateTeamMember, deleteTeamMember } from '../api/auth/teamService';

function TeamUpdate() {
    const [data, setData] = useState([]);
    const [values, setValues] = useState({
        image: null,
        name: '',
        designation: '',
        description: '',
    });
    const [editingId, setEditingId] = useState(null);

    // Fetch team data
    useEffect(() => {
        fetchTeamData();
    }, []);

    const fetchTeamData = async () => {
        try {
            const response = await getTeamMembers();
            setData(response);
        } catch (error) {
            console.error('Error fetching data:', error);
            Swal.fire('Error', error.message, 'error');
        }
    };

    const handleChanges = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image') {
            setValues((prev) => ({ ...prev, image: files[0] }));
        } else {
            setValues((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!values.image && !editingId) {
            Swal.fire('Validation Error', 'Please select an image.', 'warning');
            return;
        }

        const formData = new FormData();
        if (values.image) {
            formData.append('image', values.image);
        }
        formData.append('name', values.name);
        formData.append('designation', values.designation);
        formData.append('description', values.description);
        formData.append('date', new Date().toISOString().split('T')[0]);

        try {
            if (editingId) {
                await updateTeamMember(editingId, formData);
                Swal.fire('Updated!', 'Team member updated successfully!', 'success');
                setEditingId(null);
            } else {
                await createTeamMember(formData);
                Swal.fire('Added!', 'Team member added successfully!', 'success');
            }

            setValues({ image: null, name: '', designation: '', description: '' });
            document.getElementById('teamImage').value = ''; // reset file input
            fetchTeamData();
        } catch (error) {
            console.error('Error submitting data:', error);
            Swal.fire('Error', error.message, 'error');
        }
    };

    const handleEditClick = (item) => {
        setValues({
            image: null, // can't set file input value
            name: item.name,
            designation: item.designation,
            description: item.description,
        });
        setEditingId(item.id);
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'This will permanently delete the team member.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteTeamMember(id);
                    setData((prev) => prev.filter(item => item.id !== id));
                    Swal.fire('Deleted!', 'The team member has been deleted.', 'success');
                } catch (error) {
                    Swal.fire('Error!', error.message, 'error');
                    console.error('Delete error:', error);
                }
            }
        });
    };

    return (
        <div>
            <Sidebar />
            <div className="col-md-9 px-0" style={{ marginLeft: '215px' }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h5 className="page-title">Team Update</h5>
                        </div>
                    </div><br />

                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="teamImage" className="form-label">Team Image</label>
                            <input type="file" className="form-control" id="teamImage" accept="image/*" name="image" onChange={handleChanges} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="teamName" className="form-label">Name</label>
                            <input type="text" className="form-control" id="teamName" name="name" placeholder="Enter Name" onChange={handleChanges} value={values.name} required />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="teamDesignation" className="form-label">Designation</label>
                            <input type="text" className="form-control" id="teamDesignation" name="designation" placeholder="Enter Designation" onChange={handleChanges} value={values.designation} required />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="teamDescription" className="form-label">Description</label>

                            <input type="text" className="form-control" id="teamDescription" name="description" placeholder="Enter Description" onChange={handleChanges} value={values.description} />

                        </div>
                        <button type="submit" className="btn btn-primary">{editingId ? 'Update' : 'Add'} Team Member</button>
                    </form>
                </div>
            </div>

            <div className="col-md-10 mt-5" style={{ marginLeft: '200px' }}>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Team Image</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Description</th>
                            <th>Date</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((item, index) => (
                                <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <img
                                            src={item.imageBytes ? `data:image/jpeg;base64,${item.imageBytes}` : 'https://via.placeholder.com/100'}
                                            alt={item.name}
                                            style={{ width: '100px', height: 'auto', borderRadius: '5px' }}
                                        />
                                    </td>
                                    <td>{item.name}</td>
                                    <td>{item.designation}</td>
                                    <td>{item.description}</td>
                                    <td>{item.date || 'N/A'}</td>
                                    <td>
                                        <button className="btn btn-primary me-2" onClick={() => handleEditClick(item)}>Edit</button>
                                        <button className="btn btn-danger" onClick={() => handleDelete(item.id)}>Delete</button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">No team members found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default TeamUpdate;